export const executeAjaxScriptsFromHTMLResponse = (responseText) => {
    // const tempDiv = document.createElement('div');
    // tempDiv.innerHTML = responseText;

    // document.body.appendChild(tempDiv);

    const parser = new DOMParser();
    const doc = parser.parseFromString(responseText, 'text/html');

    const scriptElements = doc.querySelectorAll('script');
    scriptElements?.forEach((scriptElement) => {
        const newScript = document.createElement('script');

        if (scriptElement.attributes.length > 0 && Array.isArray(scriptElement.attributes)) {
            scriptElement?.attributes?.forEach((attr) => {
                if (attr.name && attr.value) {
                    newScript.setAttribute(attr.name, attr.value);
                }
            });
        }

        newScript.appendChild(document.createTextNode(scriptElement.innerHTML));
        document.body.appendChild(newScript);
    });

    // document.body.removeChild(tempDiv);
};
